import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/data/content";
import UCLogo from "@/components/site/UCLogo";

export default function Footer() {
  return (
    <footer className="bg-concrete-900 text-white">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <UCLogo className="h-12 w-12 text-white" />
              <div>
                <p className="font-display font-extrabold tracking-tight">UPSCALE CONCRETE</p>
                <p className="overline text-concrete-400">Services</p>
              </div>
            </div>
            <p className="mt-5 text-concrete-400 max-w-xs leading-relaxed">{BUSINESS.tagline}</p>
          </div>

          <div>
            <p className="overline text-concrete-500 mb-4">Contact</p>
            <div className="space-y-3">
              <a href={`tel:${BUSINESS.phoneIntl}`} className="flex items-center gap-3 text-concrete-200 hover:text-white transition-colors">
                <Phone className="h-4 w-4" /> {BUSINESS.phone}
              </a>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 text-concrete-200 hover:text-white transition-colors break-all">
                <Mail className="h-4 w-4" /> {BUSINESS.email}
              </a>
              <p className="flex items-center gap-3 text-concrete-200">
                <MapPin className="h-4 w-4" /> {BUSINESS.area}
              </p>
            </div>
          </div>

          <div>
            <p className="overline text-concrete-500 mb-4">Explore</p>
            <div className="flex flex-col gap-2">
              <a href="#services" className="text-concrete-200 hover:text-white transition-colors">Services</a>
              <a href="#work" className="text-concrete-200 hover:text-white transition-colors">Work</a>
              <a href="#process" className="text-concrete-200 hover:text-white transition-colors">Process</a>
              <a href="#contact" className="text-concrete-200 hover:text-white transition-colors">Get a quote</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="overline text-concrete-500">© {new Date().getFullYear()} Upscale Concrete Services · Sydney NSW</p>
          <a href="/admin/login" data-testid="footer-admin-link" className="overline text-concrete-600 hover:text-concrete-300 transition-colors">Owner login</a>
        </div>
      </div>
    </footer>
  );
}
